<mat-dialog-actions align="end" class="netop-dialog-actions" [ngClass]="cssClass">
    <ng-content></ng-content>
</mat-dialog-actions>